import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { BUSINESS, IMG } from "../data/content";
import { SectionLabel } from "./Section";
import { fadeUp, stagger, viewport } from "../lib/motion";

const FEED = [
  IMG.cappuccinoReal,
  IMG.almondCroissant,
  IMG.spread,
  IMG.hummus,
  IMG.burger,
  IMG.mugChandelier,
];

const InstagramFeed = () => (
  <section className="relative py-16 sm:py-32 bg-surface/40" data-testid="instagram-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
        <div>
          <SectionLabel>Instagram</SectionLabel>
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]"
          >
            Follow the <span className="text-highlight">daily pour.</span>
          </motion.h2>
        </div>
        <a
          href={BUSINESS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-btn"
          className="group inline-flex items-center gap-2 self-start text-sm font-semibold tracking-wide text-primary"
        >
          <Instagram size={18} strokeWidth={1.6} />
          @detourcoffeeco
          <span className="h-px w-6 bg-primary transition-all duration-300 group-hover:w-10" />
        </a>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3"
      >
        {FEED.map((src, i) => (
          <motion.a
            key={i}
            variants={fadeUp}
            href={BUSINESS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`instagram-post-${i}`}
            className="group relative aspect-square overflow-hidden rounded-2xl"
          >
            <img src={src} alt="Detour on Instagram" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <span className="absolute inset-0 flex items-center justify-center bg-primary/70 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <Instagram size={26} className="text-background" strokeWidth={1.5} />
            </span>
          </motion.a>
        ))}
      </motion.div>
    </div>
  </section>
);

export default InstagramFeed;
